import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestCountryBypassDatabasePut = {
    path: "/country-bypass/database",
    method: RouteHttpVerb.PUT
};
export { locationRestCountryBypassDatabasePut };
